module.exports = __webpack_public_path__ + "media/images/dividend/ic_cc_discover-6ce56603099a4b2735bcf406b95b9fad.svg";